import React, { useState, useCallback, useEffect, forwardRef } from "react";
import {
  InlineStack,
  List,
  Button,
  Text,
  Popover,
  Icon,
  Modal,
  Toast,
  FormLayout,
  ActionList,
  ButtonGroup,
} from "@shopify/polaris";
import axios from "../Assets/Lib/axios";
import {
  ArrowUpIcon,
  ColorsMajor,
  TextAlignLeftIcon,
  ImageIcon,
  TextWithImageIcon,
  ListBulletedIcon,
  PlayCircleIcon,
  CollectionFilledIcon,
  MenuVerticalIcon,
  CodeIcon,
  CategoriesIcon,
  ClockIcon,
  LayoutPopupIcon,
  ChannelsIcon,
  MenuIcon,
  LayoutSectionIcon,
  TextIcon,
} from "@shopify/polaris-icons";
import { useParams } from "react-router-dom";
import BannerSection from "./BannerSection";
import ImageWithTextSection from "./ImageWithTextSection";
import RichTextSection from "./RichTextSection";
import EllipsisText from "react-ellipsis-text";
import ListSection from "./ListSection";
import VideoSection from "./VideoSection";
import ShopifySection from "./ShopifySection";
import { ChannelsModal } from "./ChannelsModal";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import Padding from "./StylesComponents/Padding";
import PaddingStyle from "./StylesComponents/Padding";
import HeightStyle from "./StylesComponents/Height";
import WidthStyle from "./StylesComponents/Width";
import PositioningStyle from "./StylesComponents/Positioning";
import BorderStyle from "./StylesComponents/Border";
import BackgroundStyle from "./StylesComponents/Background";
import TypographyStyle from "./StylesComponents/Typography";
import ShadowStyle from "./StylesComponents/Shadow";
import CustomCssStyle from "./StylesComponents/CustomCss";
import Accordion from "react-bootstrap/Accordion";
import "react-bootstrap-accordion/dist/index.css";
import CodeSection from "./CodeSection";
import ListShopifyProducts from "./ListShopifyProducts";
import { accessDeleteSections } from "../Helpers";
import Instruction from "./Instruction";
import Countdown from "./Countdown";
import Navigation from "./Navigation";
import Popup from "./Popup";
import ObjectSection from "./ObjectSection";
import IframeSection from "./IframeSection";
import CustomBlockSection from "./CustomBlockSection";

export const SectionCollapse = forwardRef((props, ref) => {
  const { id } = useParams();
  const [isSaving, setIsSaving] = useState(false);
  // const [open, setOpen] = useState(
  //   props.sectionId === props.lastElememtId ? false : false
  // );
  const [open, setOpen] = useState(props.openState);

  const switchTitle = (param) => {
    console.log("tesssst=", param);
    switch (param) {
      case "rich_text":
        return "Rich Text";
      case "banner":
        return "Banner";
      case "image":
        return "Image with text";
      case "list":
        return "List";
      case "video":
        return "Video";
      case "shopify_collection":
        return "Shopify Collection";
      case "code":
        return "code";
      case "shopify_products_list":
        return "List of Shopify Products";
      case "countdown":
        return "Countdown";
      case "navigation":
        return "Navigation";
      case "popup":
        return "Popup";
      case "object":
        return "Object";
      case "iframe":
        return "Iframe";
      case "custom_block":
        return "Custom Block";
      default:
        return null;
    }
  };
  const switchIcon = (param) => {
    switch (param) {
      case "rich_text":
        return TextAlignLeftIcon;
      case "banner":
        return ImageIcon;
      case "image":
        return TextWithImageIcon;
      case "list":
        return ListBulletedIcon;
      case "video":
        return PlayCircleIcon;
      case "shopify_collection":
        return CollectionFilledIcon;
      case "code":
        return CodeIcon;
      case "shopify_products_list":
        return CategoriesIcon;
      case "countdown":
        return ClockIcon;
      case "popup":
        return LayoutPopupIcon;
      case "navigation":
        return MenuIcon;
      case "object":
        return LayoutSectionIcon;
      case "iframe":
        return CodeIcon;
      case "custom_block":
        return TextIcon;
      default:
        return "";
    }
  };
  const [toastMessage, setToastMessage] = useState(
    "Sections order has been successfully updated"
  );
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast content={toastMessage} onDismiss={toggleActive} />
  ) : null;

  const [optionsCollections, setOptionsCollections] = useState("");
  const [optionsProducts, setOptionsProducts] = useState("");
  const [activeChannels, setActiveChannels] = useState(false);
  const handleChangeActiveChannels = useCallback(
    () => setActiveChannels(!activeChannels),
    [activeChannels]
  );
  const handleChangeActiveChannelsDone = () => {
    setActiveChannels(false);
    setChannelsToShow(selectedChannels);
  };
  const [channels, setChannels] = useState([]);
  const [selectedChannels, setSelectedChannels] = useState([]);
  const [channelsToShow, setChannelsToShow] = useState([]);
  const handleSelectedChannels = (param) => {
    setSelectedChannels(param);
  };
  useEffect(() => {
    JSON.parse(props?.object).channels &&
      setSelectedChannels(
        JSON.parse(props?.object).channels.map((item) => item.id)
      );
    JSON.parse(props?.object).channels &&
      setChannelsToShow(
        JSON.parse(props?.object).channels.map((item) => item.id)
      );
  }, []);

  useEffect(() => {
    setOpen(props.openState);
  }, [props]);
  const [popoverActive, setPopoverActive] = useState(false);
  const togglePopoverActive = useCallback(
    () => setPopoverActive((popoverActive) => !popoverActive),
    []
  );
  const activator = (
    <Button onClick={togglePopoverActive} plain>
      <Icon source={MenuVerticalIcon} />
    </Button>
  );
  const [savingStyles, setSavingStyles] = useState(false);

  const [stylesItem, setStylesItem] = useState({
    padding: {
      top: { desktop: "", mobile: "" },
      bottom: { desktop: "", mobile: "" },
      left: { desktop: "", mobile: "" },
      right: { desktop: "", mobile: "" },
    },
    height: {
      type: { desktop: "", mobile: "" },
      customHeight: { desktop: "", mobile: "" },
      minimumHeight: { desktop: "", mobile: "" },
      maximumHeight: { desktop: "", mobile: "" },
    },
    width: {
      type: { desktop: "", mobile: "" },
      customWidth: { desktop: "", mobile: "" },
      minimumWidth: { desktop: "", mobile: "" },
      maximumWidth: { desktop: "", mobile: "" },
    },
    positioning: {
      offset: {
        top: { desktop: "", mobile: "" },
        bottom: { desktop: "", mobile: "" },
        left: { desktop: "", mobile: "" },
        right: { desktop: "", mobile: "" },
      },
      position: { desktop: "", mobile: "" },
      zIndex: { desktop: "", mobile: "" },
    },
    border: {
      color: "",
      style: "",
      width: "",
      radius: "",
    },
    background: {
      color: "",
      opacity: 100,
      gradientColor1: "",
      gradientColor2: "",
    },
    background: {
      color: "",
      opacity: 100,
      blurRadius: "",
    },
    typography: {
      fontFamily: "",
      fontSize: { desktop: "", mobile: "" },
      fontColor: "",
      textTransform: "",
    },
    customCss: "",

    // },

    // paddingTop: { desktop: "", mobile: "" },
    // paddingBottom: { desktop: "", mobile: "" },
    // paddingRight: { desktop: "", mobile: "" },
    // paddingLeft: { desktop: "", mobile: "" },
    // heightType: "",
    // minimumHeight: "",
    // maximumHeight: "",
    // customHeight: "",
    // mobileHeight: "",
    // widthType: "",
    // minimumWidth: "",
    // maximumWidth: "",
    // customWidth: "",
    // borderColor: "",
    // borderStyle: "",
    // borderWidth: "",
    // borderRadius: "",
    // offsetTop: { desktop: "", mobile: "" },
    // offsetBottom: { desktop: "", mobile: "" },
    // offsetRight: { desktop: "", mobile: "" },
    // offsetLeft: { desktop: "", mobile: "" },
    // position: { desktop: "", mobile: "" },
    // zIndex: { desktop: "", mobile: "" },
    // backgroundColor: "",
    // backgroundOpacity: 100,
  });
  useEffect(() => {
    const stylesObject =
      JSON.parse(props.object) && JSON.parse(props.object).styles
        ? JSON.parse(props.object).styles
        : null;
    stylesObject && console.log("stylesObject=", stylesObject?.paddingTop);
    stylesObject &&
      setStylesItem({
        padding: {
          top: {
            desktop: stylesObject?.padding?.top?.desktop,
            mobile: stylesObject?.padding?.top?.mobile,
          },
          bottom: {
            desktop: stylesObject?.padding?.bottom?.desktop,
            mobile: stylesObject?.padding?.bottom?.mobile,
          },
          left: {
            desktop: stylesObject?.padding?.left?.desktop,
            mobile: stylesObject?.padding?.left?.mobile,
          },
          right: {
            desktop: stylesObject?.padding?.right?.desktop,
            mobile: stylesObject?.padding?.right?.mobile,
          },
        },
        height: {
          type: {
            desktop: stylesObject?.height?.type?.desktop,
            mobile: stylesObject?.height?.type?.mobile,
          },
          customHeight: {
            desktop: stylesObject?.height?.customHeight?.desktop,
            mobile: stylesObject?.height?.customHeight?.mobile,
          },
          minimumHeight: {
            desktop: stylesObject?.height?.minimumHeight?.desktop,
            mobile: stylesObject?.height?.minimumHeight?.mobile,
          },
          maximumHeight: {
            desktop: stylesObject?.height?.maximumHeight?.desktop,
            mobile: stylesObject?.height?.maximumHeight?.mobile,
          },
        },
        width: {
          type: {
            desktop: stylesObject?.width?.type?.desktop,
            mobile: stylesObject?.width?.type?.mobile,
          },
          customWidth: {
            desktop: stylesObject?.width?.customWidth?.desktop,
            mobile: stylesObject?.width?.customWidth?.mobile,
          },
          minimumWidth: {
            desktop: stylesObject?.width?.minimumWidth?.desktop,
            mobile: stylesObject?.width?.minimumWidth?.mobile,
          },
          maximumWidth: {
            desktop: stylesObject?.width?.maximumWidth?.desktop,
            mobile: stylesObject?.width?.maximumWidth?.mobile,
          },
        },
        positioning: {
          position: {
            desktop: stylesObject?.positioning?.position?.desktop,
            mobile: stylesObject?.positioning?.position?.mobile,
          },
          zIndex: {
            desktop: stylesObject?.positioning?.zIndex?.desktop,
            mobile: stylesObject?.positioning?.zIndex?.mobile,
          },
          offset: {
            top: {
              desktop: stylesObject?.positioning?.offset?.top?.desktop,
              mobile: stylesObject?.positioning?.offset?.top?.mobile,
            },
            bottom: {
              desktop: stylesObject?.positioning?.offset?.bottom?.desktop,
              mobile: stylesObject?.positioning?.offset?.bottom?.mobile,
            },
            left: {
              desktop: stylesObject?.positioning?.offset?.left?.desktop,
              mobile: stylesObject?.positioning?.offset?.left?.mobile,
            },
            right: {
              desktop: stylesObject?.positioning?.offset?.right?.desktop,
              mobile: stylesObject?.positioning?.offset?.right?.mobile,
            },
          },
        },
        border: {
          color: stylesObject?.border?.color,
          style: stylesObject?.border?.style,
          width: stylesObject?.border?.width,
          radius: stylesObject?.border?.radius,
        },
        background: {
          color: stylesObject?.background?.color,
          opacity: stylesObject?.background?.opacity,
          gradientColor1: stylesObject?.background?.gradientColor1,
          gradientColor2: stylesObject?.background?.gradientColor2,
        },
        shadow: {
          color: stylesObject?.shadow?.color,
          opacity: stylesObject?.shadow?.opacity,
          blurRadius: stylesObject?.shadow?.blurRadius,
        },
        typography: {
          fontColor: stylesObject?.typography?.fontColor,
          fontFamily: stylesObject?.typography?.fontFamily,
          textTransform: stylesObject?.typography?.textTransform,
          fontSize: {
            desktop: stylesObject?.typography?.fontSize?.desktop,
            mobile: stylesObject?.typography?.fontSize?.mobile,
          },
        },
        customCss: stylesObject?.customCss,
      });
  }, []);
  //PADDING
  const handleChangePaddingTop = (newValue) => {
    setStylesItem({
      ...stylesItem,
      padding: {
        ...stylesItem.padding,
        top: { ...stylesItem.padding.top, desktop: newValue },
      },
    });
  };
  const handleChangePaddingBottom = (newValue) => {
    setStylesItem({
      ...stylesItem,
      padding: {
        ...stylesItem.padding,
        bottom: { ...stylesItem.padding.bottom, desktop: newValue },
      },
    });
  };
  const handleChangePaddingLeft = (newValue) => {
    setStylesItem({
      ...stylesItem,
      padding: {
        ...stylesItem.padding,
        left: { ...stylesItem.padding.left, desktop: newValue },
      },
    });
  };
  const handleChangePaddingRight = (newValue) => {
    setStylesItem({
      ...stylesItem,
      padding: {
        ...stylesItem.padding,
        right: { ...stylesItem.padding.right, desktop: newValue },
      },
    });
  };
  const handleChangePaddingTopMobile = (newValue) => {
    setStylesItem({
      ...stylesItem,
      padding: {
        ...stylesItem.padding,
        top: { ...stylesItem.padding.top, mobile: newValue },
      },
    });
  };
  const handleChangePaddingBottomMobile = (newValue) => {
    setStylesItem({
      ...stylesItem,
      padding: {
        ...stylesItem.padding,
        bottom: { ...stylesItem.padding.bottom, mobile: newValue },
      },
    });
  };
  const handleChangePaddingLeftMobile = (newValue) => {
    setStylesItem({
      ...stylesItem,
      padding: {
        ...stylesItem.padding,
        left: { ...stylesItem.padding.left, mobile: newValue },
      },
    });
  };
  const handleChangePaddingRightMobile = (newValue) => {
    setStylesItem({
      ...stylesItem,
      padding: {
        ...stylesItem.padding,
        right: { ...stylesItem.padding.right, mobile: newValue },
      },
    });
  };
  //HEIGHT
  const handleChangeHeight = (_checked, newValue) => {
    setStylesItem({
      ...stylesItem,
      height: {
        ...stylesItem.height,
        type: { ...stylesItem.height.type, desktop: newValue },
      },
    });
  };
  const handleChangeMinimumHeight = (newValue) => {
    setStylesItem({
      ...stylesItem,
      height: {
        ...stylesItem.height,
        minimumHeight: {
          ...stylesItem.height.minimumHeight,
          desktop: newValue,
        },
      },
    });
  };
  const handleChangeMaximumHeight = (newValue) => {
    setStylesItem({
      ...stylesItem,
      height: {
        ...stylesItem.height,
        maximumHeight: {
          ...stylesItem.height.maximumHeight,
          desktop: newValue,
        },
      },
    });
  };
  const handleChangeCustomHeight = (newValue) => {
    setStylesItem({
      ...stylesItem,
      height: {
        ...stylesItem.height,
        customHeight: {
          ...stylesItem.height.customHeight,
          desktop: newValue,
        },
      },
    });
  };
  const handleChangeHeightMobile = (_checked, newValue) => {
    setStylesItem({
      ...stylesItem,
      height: {
        ...stylesItem.height,
        type: { ...stylesItem.height.type, mobile: newValue },
      },
    });
  };
  const handleChangeMinimumHeightMobile = (newValue) => {
    setStylesItem({
      ...stylesItem,
      height: {
        ...stylesItem.height,
        minimumHeight: {
          ...stylesItem.height.minimumHeight,
          mobile: newValue,
        },
      },
    });
  };
  const handleChangeMaximumHeightMobile = (newValue) => {
    setStylesItem({
      ...stylesItem,
      height: {
        ...stylesItem.height,
        maximumHeight: {
          ...stylesItem.height.maximumHeight,
          mobile: newValue,
        },
      },
    });
  };
  const handleChangeCustomHeightMobile = (newValue) => {
    setStylesItem({
      ...stylesItem,
      height: {
        ...stylesItem.height,
        customHeight: {
          ...stylesItem.height.customHeight,
          mobile: newValue,
        },
      },
    });
  };
  //WIDHT
  const handleChangeWidth = (_checked, newValue) => {
    setStylesItem({
      ...stylesItem,
      width: {
        ...stylesItem.width,
        type: { ...stylesItem.width.type, desktop: newValue },
      },
    });
  };
  const handleChangeMinimumWidth = (newValue) => {
    setStylesItem({
      ...stylesItem,
      width: {
        ...stylesItem.width,
        minimumWidth: {
          ...stylesItem.width.minimumWidth,
          desktop: newValue,
        },
      },
    });
  };
  const handleChangeMaximumWidth = (newValue) => {
    setStylesItem({
      ...stylesItem,
      width: {
        ...stylesItem.width,
        maximumWidth: {
          ...stylesItem.width.maximumWidth,
          desktop: newValue,
        },
      },
    });
  };
  const handleChangeCustomWidth = (newValue) => {
    setStylesItem({
      ...stylesItem,
      width: {
        ...stylesItem.width,
        customWidth: {
          ...stylesItem.width.customWidth,
          desktop: newValue,
        },
      },
    });
  };
  const handleChangeWidthMobile = (_checked, newValue) => {
    setStylesItem({
      ...stylesItem,
      width: {
        ...stylesItem.width,
        type: { ...stylesItem.width.type, mobile: newValue },
      },
    });
  };
  const handleChangeMinimumWidthMobile = (newValue) => {
    setStylesItem({
      ...stylesItem,
      width: {
        ...stylesItem.width,
        minimumWidth: {
          ...stylesItem.width.minimumWidth,
          mobile: newValue,
        },
      },
    });
  };
  const handleChangeMaximumWidthMobile = (newValue) => {
    setStylesItem({
      ...stylesItem,
      width: {
        ...stylesItem.width,
        maximumWidth: {
          ...stylesItem.width.maximumWidth,
          mobile: newValue,
        },
      },
    });
  };
  const handleChangeCustomWidthMobile = (newValue) => {
    setStylesItem({
      ...stylesItem,
      width: {
        ...stylesItem.width,
        customWidth: {
          ...stylesItem.width.customWidth,
          mobile: newValue,
        },
      },
    });
  };
  //BORDER
  const handleChangeBorderWidth = (newValue) => {
    setStylesItem({
      ...stylesItem,
      border: { ...stylesItem.border, width: newValue },
    });
  };
  const handleChangeBorderRadius = (newValue) => {
    setStylesItem({
      ...stylesItem,
      border: { ...stylesItem.border, radius: newValue },
    });
  };
  const handleSelectChangeBorderStyle = (newValue) => {
    setStylesItem({
      ...stylesItem,
      border: { ...stylesItem.border, style: newValue },
    });
  };
  const handleSelectChangeBorderColor = (newValue) => {
    setStylesItem({
      ...stylesItem,
      border: { ...stylesItem.border, color: newValue },
    });
  };
  //POSITIONING
  const handleChangeOffsetTop = (newValue) => {
    setStylesItem({
      ...stylesItem,
      positioning: {
        ...stylesItem.positioning,
        offset: {
          ...stylesItem.positioning.offset,
          top: { ...stylesItem.positioning.offset.top, desktop: newValue },
        },
      },
    });
  };
  const handleChangeOffsetBottom = (newValue) => {
    setStylesItem({
      ...stylesItem,
      positioning: {
        ...stylesItem.positioning,
        offset: {
          ...stylesItem.positioning.offset,
          bottom: {
            ...stylesItem.positioning.offset.bottom,
            desktop: newValue,
          },
        },
      },
    });
  };
  const handleChangeOffsetLeft = (newValue) => {
    setStylesItem({
      ...stylesItem,
      positioning: {
        ...stylesItem.positioning,
        offset: {
          ...stylesItem.positioning.offset,
          left: {
            ...stylesItem.positioning.offset.left,
            desktop: newValue,
          },
        },
      },
    });
  };
  const handleChangeOffsetRight = (newValue) => {
    setStylesItem({
      ...stylesItem,
      positioning: {
        ...stylesItem.positioning,
        offset: {
          ...stylesItem.positioning.offset,
          right: {
            ...stylesItem.positioning.offset.right,
            desktop: newValue,
          },
        },
      },
    });
  };
  const handleChangeOffsetTopMobile = (newValue) => {
    setStylesItem({
      ...stylesItem,
      positioning: {
        ...stylesItem.positioning,
        offset: {
          ...stylesItem.positioning.offset,
          top: {
            ...stylesItem.positioning.offset.top,
            mobile: newValue,
          },
        },
      },
    });
  };
  const handleChangeOffsetBottomMobile = (newValue) => {
    setStylesItem({
      ...stylesItem,
      positioning: {
        ...stylesItem.positioning,
        offset: {
          ...stylesItem.positioning.offset,
          bottom: {
            ...stylesItem.positioning.offset.bottom,
            mobile: newValue,
          },
        },
      },
    });
  };
  const handleChangeOffsetLeftMobile = (newValue) => {
    setStylesItem({
      ...stylesItem,
      positioning: {
        ...stylesItem.positioning,
        offset: {
          ...stylesItem.positioning.offset,
          left: {
            ...stylesItem.positioning.offset.left,
            mobile: newValue,
          },
        },
      },
    });
  };
  const handleChangeOffsetRightMobile = (newValue) => {
    setStylesItem({
      ...stylesItem,
      positioning: {
        ...stylesItem.positioning,
        offset: {
          ...stylesItem.positioning.offset,
          right: {
            ...stylesItem.positioning.offset.right,
            mobile: newValue,
          },
        },
      },
    });
  };
  const handleSelectChangePosition = (newValue) => {
    setStylesItem({
      ...stylesItem,
      positioning: {
        ...stylesItem.positioning,
        position: {
          ...stylesItem.positioning.position,
          desktop: newValue,
        },
      },
    });
  };
  const handleSelectChangePositionMobile = (newValue) => {
    setStylesItem({
      ...stylesItem,
      positioning: {
        ...stylesItem.positioning,
        position: {
          ...stylesItem.positioning.position,
          mobile: newValue,
        },
      },
    });
  };
  const handleChangeZindex = (newValue) => {
    setStylesItem({
      ...stylesItem,
      positioning: {
        ...stylesItem.positioning,
        zIndex: {
          ...stylesItem.positioning.zIndex,
          desktop: newValue,
        },
      },
    });
  };
  const handleChangeZindexMobile = (newValue) => {
    setStylesItem({
      ...stylesItem,
      positioning: {
        ...stylesItem.positioning,
        zIndex: {
          ...stylesItem.positioning.zIndex,
          mobile: newValue,
        },
      },
    });
  };
  //BACKGROUND
  const handleSelectChangeBackgroundColor = (newValue) => {
    setStylesItem({
      ...stylesItem,
      background: { ...stylesItem.background, color: newValue },
    });
  };
  const handleChangeBackgroundOpacity = (newValue) => {
    setStylesItem({
      ...stylesItem,
      background: { ...stylesItem.background, opacity: newValue },
    });
  };
  const handleSelectChangeBackgroundGradientColor1 = (newValue) => {
    setStylesItem({
      ...stylesItem,
      background: { ...stylesItem.background, gradientColor1: newValue },
    });
  };
  const handleSelectChangeBackgroundGradientColor2 = (newValue) => {
    setStylesItem({
      ...stylesItem,
      background: { ...stylesItem.background, gradientColor2: newValue },
    });
  };
  //TYPOGRAPHY
  const handleChangeTextTransform = (_checked, newValue) => {
    setStylesItem({
      ...stylesItem,
      typography: { ...stylesItem.typography, textTransform: newValue },
    });
  };
  const handleChangeFontSize = (newValue) => {
    setStylesItem({
      ...stylesItem,
      typography: {
        ...stylesItem.typography,
        fontSize: {
          ...stylesItem.typography.fontSize,
          desktop: newValue,
        },
      },
    });
  };
  const handleChangeFontSizeMobile = (newValue) => {
    setStylesItem({
      ...stylesItem,
      typography: {
        ...stylesItem.typography,
        fontSize: {
          ...stylesItem.typography.fontSize,
          mobile: newValue,
        },
      },
    });
  };
  const handleSelectChangeFontColor = (newValue) => {
    setStylesItem({
      ...stylesItem,
      typography: { ...stylesItem.typography, fontColor: newValue },
    });
  };
  const handleSelectChangeFontFamily = (newValue) => {
    setStylesItem({
      ...stylesItem,
      typography: { ...stylesItem.typography, fontFamily: newValue },
    });
  };
  //SHADOW
  const handleSelectChangeShadowColor = (newValue) => {
    setStylesItem({
      ...stylesItem,
      shadow: { ...stylesItem.shadow, color: newValue },
    });
  };
  const handleChangeShadowOpacity = (newValue) => {
    setStylesItem({
      ...stylesItem,
      shadow: { ...stylesItem.shadow, opacity: newValue },
    });
  };
  const handleChangeShadowBlurRadius = (newValue) => {
    setStylesItem({
      ...stylesItem,
      shadow: { ...stylesItem.shadow, blurRadius: newValue },
    });
  };
  //CUSTOM CSS
  const handleSelectChangeCustomCss = (newValue) => {
    setStylesItem({
      ...stylesItem,
      customCss: newValue,
    });
  };
  const [stylesSliderOpen, setStylesSliderOpen] = useState(false);

  const handleCustomizeStyles = () => {
    setStylesSliderOpen(true);
    if (typeof window != "undefined" && window.document) {
      document.body.style.overflow = "hidden";
    }
  };
  return (
    <div>
      {/* <h1>{JSON.stringify(stylesItem)}</h1> */}
      <div className="accordion-item" id={props.id}>
        <h2
          className="accordion-header"
          id="heading-m3q819"
          {...props.dragHandleProps}
        >
          <div
            onClick={() => {
              props.updateOpenArrayStateClose(props.sectionId);
              //setOpen(!open);
              // props.changeOpenValue(!open);
            }}
            role="button"
            tabIndex="0"
            className={`accordion-button ${
              open ? "accordion-buttonClicked" : ""
            } collapsed ${open ? "clickedAccordion" : ""}`}
            type="button"
            aria-expanded="false"
            aria-controls="collapse-m3q819"
            aria-label="aa"
          >
            {
              <InlineStack gap="200" align="center" blockAlign="center">
                {/* Replace Stack.Item with just a child element */}
                <div>
                  <div
                    style={{
                      minWidth: "10rem",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <div style={{ width: "2rem", opacity: "0.5" }}>
                      <Icon source={switchIcon(props.type)} color="subdued" />
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Text variant="bodyMd" as="p" fontWeight="regular">
                        {`${
                          JSON.parse(props?.object) &&
                          JSON.parse(props?.object)?.title["en"]
                            ? `${JSON.parse(props?.object)
                                .title["en"].replace(/<[^>]+>/g, "")
                                .replace(/&nbsp;/g, "")
                                .replaceAll(";;;", " ")}`
                            : switchTitle(props.type)
                        }`}
                      </Text>
                      {props.previewState === "inline-preview" ? (
                        <div className="previewarea">
                          <Text variant="bodyMd" as="p" fontWeight="regular">
                            {props.type === "rich_text" &&
                              JSON.parse(props?.object)?.details &&
                              JSON.parse(props?.object)?.details?.text &&
                              JSON.parse(props?.object)?.details?.text[
                                "en"
                              ] && (
                                <EllipsisText
                                  text={`${JSON.parse(props?.object)
                                    .details.text["en"].replace(/<[^>]+>/g, "")
                                    .replace(/&nbsp;/g, "")}`}
                                  length={300}
                                />
                              )}

                            {props.type === "banner" &&
                              JSON.parse(props?.object)?.details &&
                              JSON.parse(props?.object)?.details?.image &&
                              JSON.parse(props?.object)?.details?.image[
                                "en"
                              ] && (
                                <img
                                  className="mt-2"
                                  width={60}
                                  src={
                                    JSON.parse(props?.object)?.details?.image[
                                      "en"
                                    ]
                                  }
                                />
                              )}

                            {props.type === "image" &&
                              JSON.parse(props?.object)?.details &&
                              JSON.parse(props?.object)?.details?.image &&
                              JSON.parse(props?.object)?.details?.image[
                                "en"
                              ] && (
                                <img
                                  className="mt-2"
                                  width={60}
                                  src={
                                    JSON.parse(props?.object)?.details?.image[
                                      "en"
                                    ]
                                  }
                                />
                              )}

                            {props.type === "list" &&
                              JSON.parse(props?.object)?.details &&
                              JSON.parse(props?.object)?.details?.list && (
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                  }}
                                >
                                  {JSON.parse(
                                    props?.object
                                  )?.details?.list?.map((item, index) => {
                                    return (
                                      <div
                                        style={{ marginRight: "1rem" }}
                                        key={item.id}
                                      >
                                        {item.image?.en ? (
                                          <img
                                            src={
                                              item?.image?.en
                                                ? item?.image?.en
                                                : ""
                                            }
                                            width={50}
                                            height={50}
                                            style={{ objectFit: "cover" }}
                                          ></img>
                                        ) : null}
                                      </div>
                                    );
                                  })}
                                </div>
                              )}
                            {/* 
                            {props.type === "shopify_collection" &&
                              JSON.parse(props?.object)?.details &&
                              JSON.parse(props?.object)?.details?.products && (
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                  }}
                                  className="boxTemplates"
                                >
                                  {JSON.parse(
                                    props?.object
                                  )?.details?.products?.map((item, index) => {
                                    return (
                                      <div
                                        style={{ marginRight: "1rem" }}
                                        key={item.id}
                                      >
                                        {item.images[0]?.src ? (
                                          <img
                                            src={
                                              item?.images[0]?.src
                                                ? item?.images[0]?.src
                                                : ""
                                            }
                                            width={50}
                                            height={50}
                                            style={{ objectFit: "cover" }}
                                          ></img>
                                        ) : null}
                                      </div>
                                    );
                                  })}
                                </div>
                              )} */}

                            {/* {props.templates &&
                              JSON.parse(props?.object) &&
                              JSON.parse(props?.object)?.template_id !== null &&
                              findElementByID(
                                props?.templates,
                                JSON.parse(props?.object)?.template_id
                              ) &&
                              findElementByID(
                                props?.templates,
                                JSON.parse(props?.object)?.template_id
                              )?.description && (
                                <p>
                                  {`Template (${
                                    findElementByID(
                                      props?.templates,
                                      JSON.parse(props?.object)?.template_id
                                    ).description
                                  })`}
                                </p>
                              )} */}
                          </Text>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </InlineStack>
            }
          </div>
        </h2>
        <div
          id="collapse-m3q819"
          aria-labelledby="heading-m3q819"
          className="accordion-collapse"
          style={{
            height: !open && "0px",
            transition: "height 0.2s ease 0s",
            overflowX: "auto",
          }}
        >
          <div className="accordion-body">
            <div className="my-3 pb-4">
              <div style={{ float: "right" }} className="rowDiv">
                <ButtonGroup>
                  <Button
                    plain
                    onClick={() => setActiveChannels(true)}
                    icon={ChannelsIcon}
                  >
                    Manage Channels
                  </Button>
                  {/* <Button plain onClick={() => setActiveChannels(true)}>
                    Translate
                  </Button> */}
                  {/* <Button
                    plain
                    onClick={() => handleCustomizeStyles()}
                    icon={ColorsMajor}
                  >
                    Customize Styles
                  </Button> */}
                </ButtonGroup>
                {props.adminRole !== "Editor" && (
                  <div className="ms-3">
                    <Popover
                      active={popoverActive}
                      activator={activator}
                      autofocusTarget="first-node"
                      onClose={togglePopoverActive}
                    >
                      <ActionList
                        actionRole="menuitem"
                        items={[
                          {
                            content: "Delete",
                            onAction: () => {
                              props.handleShowDeleteModal(props.sectionId);
                            },
                            disabled: !accessDeleteSections(),
                          },
                          {
                            content: "Copy Handle",
                            onAction: () => {
                              navigator.clipboard.writeText(
                                JSON.parse(props.object).handle
                              );
                            },
                          },
                          // {
                          //   content: "Customize Styles",
                          //   onAction: () => {
                          //     setStylesSliderOpen(true);
                          //     if (
                          //       typeof window != "undefined" &&
                          //       window.document
                          //     ) {
                          //       document.body.style.overflow = "hidden";
                          //     }
                          //   },
                          // },
                        ]}
                      />
                    </Popover>
                  </div>
                )}
              </div>
              <FormLayout>
                <Instruction
                  text={JSON.parse(props.object).instructions}
                  pageId={id}
                  sectionId={props.sectionId}
                  handleRefreshSections={props.handleRefreshSections}
                />
                <hr />
              </FormLayout>
              {/* <FormLayout>
                {channelsToShow && channelsToShow.length ? (
                  <FormLayout>
                    <List type="bullet">
                      {channelsToShow.map((element, index) => {
                        return (
                          <List.Item key={index}>
                            {findElementByID(props.channels, element) &&
                              findElementByID(props.channels, element).label &&
                              findElementByID(props.channels, element).label}
                          </List.Item>
                        );
                      })}
                    </List>
                    <hr />
                  </FormLayout>
                ) : (
                  <Text as="p" fontWeight="regular" color="subdued">
                    No channels found. Click on Manage Channels button to manage
                    channels.
                  </Text>
                )}
              </FormLayout> */}
            </div>

            {props.type === "rich_text" && (
              <RichTextSection
                object={props.object}
                languagesArray={props.languagesArray}
                sectionId={props.sectionId}
                handleSaveAndRefresh={props.handleSaveAndRefresh}
                isSaving={props.isSaving}
                handleSavingState={props.handleSavingState}
                handleDeleteAndRefresh={props.handleDeleteAndRefresh}
                handleSaveWithoutRefresh={props.handleSaveWithoutRefresh}
                urlType={props.urlType}
                handleRefreshSections={props.handleRefreshSections}
                pagesArray={props.pagesArray}
                blogsArray={props.blogsArray}
                collectionsArray={props.collectionsArray}
                productsArray={props.productsArray}
                selectedChannels={selectedChannels}
                handleCustomizeStyles={handleCustomizeStyles}
                templates={props.templates.filter(
                  ({ section_type }) => section_type === "rich_text"
                )}
                shopifyDomainFound={props.shopifyDomainFound}
              />
            )}

            {props.type === "object" && (
              <ObjectSection
                object={props.object}
                languagesArray={props.languagesArray}
                sectionId={props.sectionId}
                handleSaveAndRefresh={props.handleSaveAndRefresh}
                isSaving={props.isSaving}
                handleSavingState={props.handleSavingState}
                handleDeleteAndRefresh={props.handleDeleteAndRefresh}
                handleSaveWithoutRefresh={props.handleSaveWithoutRefresh}
                urlType={props.urlType}
                handleRefreshSections={props.handleRefreshSections}
                pagesArray={props.pagesArray}
                blogsArray={props.blogsArray}
                collectionsArray={props.collectionsArray}
                productsArray={props.productsArray}
                selectedChannels={selectedChannels}
                handleCustomizeStyles={handleCustomizeStyles}
                templates={props.templates.filter(
                  ({ section_type }) => section_type === "object"
                )}
                shopifyDomainFound={props.shopifyDomainFound}
              />
            )}

            {props.type === "navigation" && (
              <Navigation
                object={props.object}
                languagesArray={props.languagesArray}
                sectionId={props.sectionId}
                handleSaveAndRefresh={props.handleSaveAndRefresh}
                isSaving={props.isSaving}
                handleSavingState={props.handleSavingState}
                handleDeleteAndRefresh={props.handleDeleteAndRefresh}
                handleSaveWithoutRefresh={props.handleSaveWithoutRefresh}
                urlType={props.urlType}
                handleRefreshSections={props.handleRefreshSections}
                pagesArray={props.pagesArray}
                menusArray={props.menusArray}
                blogsArray={props.blogsArray}
                collectionsArray={props.collectionsArray}
                productsArray={props.productsArray}
                selectedChannels={selectedChannels}
                handleCustomizeStyles={handleCustomizeStyles}
                templates={props.templates.filter(
                  ({ section_type }) => section_type === "rich_text"
                )}
                shopifyDomainFound={props.shopifyDomainFound}
              />
            )}

            {props.type === "popup" && (
              <Popup
                object={props.object}
                languagesArray={props.languagesArray}
                sectionId={props.sectionId}
                handleSaveAndRefresh={props.handleSaveAndRefresh}
                isSaving={props.isSaving}
                handleSavingState={props.handleSavingState}
                handleDeleteAndRefresh={props.handleDeleteAndRefresh}
                handleSaveWithoutRefresh={props.handleSaveWithoutRefresh}
                urlType={props.urlType}
                handleRefreshSections={props.handleRefreshSections}
                pagesArray={props.pagesArray}
                menusArray={props.menusArray}
                blogsArray={props.blogsArray}
                collectionsArray={props.collectionsArray}
                productsArray={props.productsArray}
                selectedChannels={selectedChannels}
                handleCustomizeStyles={handleCustomizeStyles}
                templates={props.templates.filter(
                  ({ section_type }) => section_type === "rich_text"
                )}
                shopifyDomainFound={props.shopifyDomainFound}
              />
            )}

            {props.type === "countdown" && (
              <Countdown
                object={props.object}
                languagesArray={props.languagesArray}
                sectionId={props.sectionId}
                handleSaveAndRefresh={props.handleSaveAndRefresh}
                isSaving={props.isSaving}
                handleSavingState={props.handleSavingState}
                handleDeleteAndRefresh={props.handleDeleteAndRefresh}
                handleSaveWithoutRefresh={props.handleSaveWithoutRefresh}
                urlType={props.urlType}
                handleRefreshSections={props.handleRefreshSections}
                pagesArray={props.pagesArray}
                blogsArray={props.blogsArray}
                collectionsArray={props.collectionsArray}
                productsArray={props.productsArray}
                selectedChannels={selectedChannels}
                handleCustomizeStyles={handleCustomizeStyles}
                templates={props.templates.filter(
                  ({ section_type }) => section_type === "rich_text"
                )}
                shopifyDomainFound={props.shopifyDomainFound}
              />
            )}
            {props.type === "banner" && (
              <BannerSection
                object={props.object}
                languagesArray={props.languagesArray}
                pagesArray={props.pagesArray}
                blogsArray={props.blogsArray}
                collectionsArray={props.collectionsArray}
                productsArray={props.productsArray}
                sectionId={props.sectionId}
                handleSaveAndRefresh={props.handleSaveAndRefresh}
                isSaving={props.isSaving}
                handleSavingState={props.handleSavingState}
                handleSaveWithoutRefresh={props.handleSaveWithoutRefresh}
                handleDeleteAndRefresh={props.handleDeleteAndRefresh}
                urlType={props.urlType}
                handleRefreshSections={props.handleRefreshSections}
                selectedChannels={selectedChannels}
                handleCustomizeStyles={handleCustomizeStyles}
                templates={props.templates.filter(
                  ({ section_type }) => section_type === "banner"
                )}
                shopifyDomainFound={props.shopifyDomainFound}
                handleResetSavingState={props.handleResetSavingState}
              />
            )}

            {props.type === "custom_block" && (
              <CustomBlockSection
                object={props.object}
                languagesArray={props.languagesArray}
                pagesArray={props.pagesArray}
                blogsArray={props.blogsArray}
                collectionsArray={props.collectionsArray}
                productsArray={props.productsArray}
                sectionId={props.sectionId}
                handleSaveAndRefresh={props.handleSaveAndRefresh}
                isSaving={props.isSaving}
                handleSavingState={props.handleSavingState}
                handleSaveWithoutRefresh={props.handleSaveWithoutRefresh}
                handleDeleteAndRefresh={props.handleDeleteAndRefresh}
                urlType={props.urlType}
                handleRefreshSections={props.handleRefreshSections}
                selectedChannels={selectedChannels}
                handleCustomizeStyles={handleCustomizeStyles}
                templates={props.templates.filter(
                  ({ section_type }) => section_type === "custom_block"
                )}
                shopifyDomainFound={props.shopifyDomainFound}
                handleResetSavingState={props.handleResetSavingState}
              />
            )}
            {props.type === "shopify_collection" && (
              <ShopifySection
                object={props.object}
                languagesArray={props.languagesArray}
                sectionId={props.sectionId}
                handleSaveAndRefresh={props.handleSaveAndRefresh}
                isSaving={props.isSaving}
                handleSavingState={props.handleSavingState}
                handleSaveWithoutRefresh={props.handleSaveWithoutRefresh}
                handleDeleteAndRefresh={props.handleDeleteAndRefresh}
                urlType={props.urlType}
                handleResetSavingState={props.handleResetSavingState}
                handleRefreshSections={props.handleRefreshSections}
                selectedChannels={selectedChannels}
                handleCustomizeStyles={handleCustomizeStyles}
                templates={props.templates.filter(
                  ({ section_type }) => section_type === "shopify_collection"
                )}
                collectionsArray={props.collectionsArray}
              />
            )}
            {props.type === "image" && (
              <ImageWithTextSection
                object={props.object}
                languagesArray={props.languagesArray}
                sectionId={props.sectionId}
                handleSaveAndRefresh={props.handleSaveAndRefresh}
                isSaving={props.isSaving}
                handleSavingState={props.handleSavingState}
                handleDeleteAndRefresh={props.handleDeleteAndRefresh}
                handleSaveWithoutRefresh={props.handleSaveWithoutRefresh}
                urlType={props.urlType}
                handleRefreshSections={props.handleRefreshSections}
                pagesArray={props.pagesArray}
                blogsArray={props.blogsArray}
                collectionsArray={props.collectionsArray}
                productsArray={props.productsArray}
                selectedChannels={selectedChannels}
                handleCustomizeStyles={handleCustomizeStyles}
                templates={props.templates.filter(
                  ({ section_type }) => section_type === "image"
                )}
                shopifyDomainFound={props.shopifyDomainFound}
                handleResetSavingState={props.handleResetSavingState}
              />
            )}
            {props.type === "list" && (
              <ListSection
                object={props.object}
                languagesArray={props.languagesArray}
                sectionId={props.sectionId}
                handleSaveAndRefresh={props.handleSaveAndRefresh}
                isSaving={props.isSaving}
                handleSavingState={props.handleSavingState}
                handleDeleteAndRefresh={props.handleDeleteAndRefresh}
                handleRefreshSections={props.handleRefreshSections}
                handleSaveWithoutRefresh={props.handleSaveWithoutRefresh}
                urlType={props.urlType}
                selectedChannels={selectedChannels}
                handleCustomizeStyles={handleCustomizeStyles}
                templates={props.templates.filter(
                  ({ section_type }) => section_type === "list"
                )}
                handleResetSavingState={props.handleResetSavingState}
                pagesArray={props.pagesArray}
                blogsArray={props.blogsArray}
                collectionsArray={props.collectionsArray}
                productsArray={props.productsArray}
                refreshApi={props.refreshApi}
              />
            )}

            {props.type === "shopify_products_list" && (
              <ListShopifyProducts
                object={props.object}
                languagesArray={props.languagesArray}
                sectionId={props.sectionId}
                handleSaveAndRefresh={props.handleSaveAndRefresh}
                isSaving={props.isSaving}
                handleSavingState={props.handleSavingState}
                handleDeleteAndRefresh={props.handleDeleteAndRefresh}
                handleRefreshSections={props.handleRefreshSections}
                handleSaveWithoutRefresh={props.handleSaveWithoutRefresh}
                urlType={props.urlType}
                selectedChannels={selectedChannels}
                handleCustomizeStyles={handleCustomizeStyles}
                templates={props.templates.filter(
                  ({ section_type }) => section_type === "shopify_products_list"
                )}
              />
            )}

            {props.type === "video" && (
              <VideoSection
                object={props.object}
                languagesArray={props.languagesArray}
                sectionId={props.sectionId}
                handleSaveAndRefresh={props.handleSaveAndRefresh}
                isSaving={props.isSaving}
                handleSavingState={props.handleSavingState}
                handleDeleteAndRefresh={props.handleDeleteAndRefresh}
                handleSaveWithoutRefresh={props.handleSaveWithoutRefresh}
                urlType={props.urlType}
                handleRefreshSections={props.handleRefreshSections}
                selectedChannels={selectedChannels}
                handleCustomizeStyles={handleCustomizeStyles}
                templates={props.templates.filter(
                  ({ section_type }) => section_type === "video"
                )}
              />
            )}
            {props.type === "code" && (
              <CodeSection
                object={props.object}
                languagesArray={props.languagesArray}
                sectionId={props.sectionId}
                handleSaveAndRefresh={props.handleSaveAndRefresh}
                isSaving={props.isSaving}
                handleSavingState={props.handleSavingState}
                handleDeleteAndRefresh={props.handleDeleteAndRefresh}
                handleSaveWithoutRefresh={props.handleSaveWithoutRefresh}
                urlType={props.urlType}
                handleRefreshSections={props.handleRefreshSections}
                selectedChannels={selectedChannels}
                handleCustomizeStyles={handleCustomizeStyles}
                templates={props.templates.filter(
                  ({ section_type }) => section_type === "code"
                )}
              />
            )}

            {props.type === "iframe" && (
              <IframeSection
                object={props.object}
                languagesArray={props.languagesArray}
                sectionId={props.sectionId}
                handleSaveAndRefresh={props.handleSaveAndRefresh}
                isSaving={props.isSaving}
                handleSavingState={props.handleSavingState}
                handleDeleteAndRefresh={props.handleDeleteAndRefresh}
                handleSaveWithoutRefresh={props.handleSaveWithoutRefresh}
                urlType={props.urlType}
                handleRefreshSections={props.handleRefreshSections}
                selectedChannels={selectedChannels}
                handleCustomizeStyles={handleCustomizeStyles}
                templates={props.templates.filter(
                  ({ section_type }) => section_type === "iframe"
                )}
              />
            )}
          </div>
        </div>
      </div>
      <SlidingPane
        className="some-custom-class"
        overlayClassName="some-custom-overlay-class"
        isOpen={stylesSliderOpen}
        title="Section Styles"
        // from="bottom"
        // subtitle="Optional subtitle."
        onRequestClose={() => {
          setStylesSliderOpen(false);
          if (typeof window != "undefined" && window.document) {
            document.body.style.overflow = "visible";
          }
        }}
        width="40%"
      >
        <Accordion defaultActiveKey="0" flush>
          <Accordion.Item eventKey="0">
            <Accordion.Header>SECTION PADDING</Accordion.Header>
            <Accordion.Body>
              <PaddingStyle
                item={stylesItem}
                handleChangePaddingTop={handleChangePaddingTop}
                handleChangePaddingBottom={handleChangePaddingBottom}
                handleChangePaddingLeft={handleChangePaddingLeft}
                handleChangePaddingRight={handleChangePaddingRight}
                handleChangePaddingTopMobile={handleChangePaddingTopMobile}
                handleChangePaddingBottomMobile={
                  handleChangePaddingBottomMobile
                }
                handleChangePaddingLeftMobile={handleChangePaddingLeftMobile}
                handleChangePaddingRightMobile={handleChangePaddingRightMobile}
              />
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1">
            <Accordion.Header>SECTION HEIGHT</Accordion.Header>
            <Accordion.Body>
              <HeightStyle
                item={stylesItem}
                handleChangeHeight={handleChangeHeight}
                handleChangeMinimumHeight={handleChangeMinimumHeight}
                handleChangeMaximumHeight={handleChangeMaximumHeight}
                handleChangeCustomHeight={handleChangeCustomHeight}
                handleChangeHeightMobile={handleChangeHeightMobile}
                handleChangeMinimumHeightMobile={
                  handleChangeMinimumHeightMobile
                }
                handleChangeMaximumHeightMobile={
                  handleChangeMaximumHeightMobile
                }
                handleChangeCustomHeightMobile={handleChangeCustomHeightMobile}
                // handleChangeMobileHeight={handleChangeMobileHeight}
              />
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2">
            <Accordion.Header>SECTION WIDTH</Accordion.Header>
            <Accordion.Body>
              <WidthStyle
                item={stylesItem}
                handleChangeWidth={handleChangeWidth}
                handleChangeMinimumWidth={handleChangeMinimumWidth}
                handleChangeMaximumWidth={handleChangeMaximumWidth}
                handleChangeCustomWidth={handleChangeCustomWidth}
                handleChangeWidthMobile={handleChangeWidthMobile}
                handleChangeMinimumWidthMobile={handleChangeMinimumWidthMobile}
                handleChangeMaximumWidthMobile={handleChangeMaximumWidthMobile}
                handleChangeCustomWidthMobile={handleChangeCustomWidthMobile}
              />
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="3">
            <Accordion.Header>POSITIONING</Accordion.Header>
            <Accordion.Body>
              <PositioningStyle
                item={stylesItem}
                handleChangeOffsetTop={handleChangeOffsetTop}
                handleChangeOffsetBottom={handleChangeOffsetBottom}
                handleChangeOffsetLeft={handleChangeOffsetLeft}
                handleChangeOffsetRight={handleChangeOffsetRight}
                handleChangeOffsetTopMobile={handleChangeOffsetTopMobile}
                handleChangeOffsetBottomMobile={handleChangeOffsetBottomMobile}
                handleChangeOffsetLeftMobile={handleChangeOffsetLeftMobile}
                handleChangeOffsetRightMobile={handleChangeOffsetRightMobile}
                handleSelectChangePosition={handleSelectChangePosition}
                handleSelectChangePositionMobile={
                  handleSelectChangePositionMobile
                }
                handleChangeZindex={handleChangeZindex}
                handleChangeZindexMobile={handleChangeZindexMobile}
              />
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="4">
            <Accordion.Header>BACKGROUND</Accordion.Header>
            <Accordion.Body>
              <BackgroundStyle
                item={stylesItem}
                handleSelectChangeBackgroundColor={
                  handleSelectChangeBackgroundColor
                }
                handleChangeBackgroundOpacity={handleChangeBackgroundOpacity}
                handleSelectChangeBackgroundGradientColor1={
                  handleSelectChangeBackgroundGradientColor1
                }
                handleSelectChangeBackgroundGradientColor2={
                  handleSelectChangeBackgroundGradientColor2
                }
              />
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="5">
            <Accordion.Header>BORDER</Accordion.Header>
            <Accordion.Body>
              <BorderStyle
                item={stylesItem}
                handleChangeBorderWidth={handleChangeBorderWidth}
                handleChangeBorderRadius={handleChangeBorderRadius}
                handleSelectChangeBorderStyle={handleSelectChangeBorderStyle}
                handleSelectChangeBorderColor={handleSelectChangeBorderColor}
              />
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="6">
            <Accordion.Header>TYPOGRAPHY</Accordion.Header>
            <Accordion.Body>
              <TypographyStyle
                item={stylesItem}
                handleSelectChangeFontFamily={handleSelectChangeFontFamily}
                handleSelectChangeFontColor={handleSelectChangeFontColor}
                handleChangeFontSize={handleChangeFontSize}
                handleChangeFontSizeMobile={handleChangeFontSizeMobile}
                handleChangeTextTransform={handleChangeTextTransform}
              />
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="7">
            <Accordion.Header>SHADOW</Accordion.Header>
            <Accordion.Body>
              <ShadowStyle
                item={stylesItem}
                handleSelectChangeShadowColor={handleSelectChangeShadowColor}
                handleChangeShadowOpacity={handleChangeShadowOpacity}
                handleChangeShadowBlurRadius={handleChangeShadowBlurRadius}
              />
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="8">
            <Accordion.Header>CUSTOM CSS</Accordion.Header>
            <Accordion.Body>
              <CustomCssStyle
                item={stylesItem}
                handleSelectChangeCustomCss={handleSelectChangeCustomCss}
              />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

        {/* <PaddingStyle
          item={stylesItem}
          handleChangePaddingTop={handleChangePaddingTop}
          handleChangePaddingBottom={handleChangePaddingBottom}
          handleChangePaddingLeft={handleChangePaddingLeft}
          handleChangePaddingRight={handleChangePaddingRight}
          handleChangePaddingTopMobile={handleChangePaddingTopMobile}
          handleChangePaddingBottomMobile={handleChangePaddingBottomMobile}
          handleChangePaddingLeftMobile={handleChangePaddingLeftMobile}
          handleChangePaddingRightMobile={handleChangePaddingRightMobile}
        />
        <div className="mt-5">
          <HeightStyle
            item={stylesItem}
            handleChangeHeight={handleChangeHeight}
            handleChangeMinimumHeight={handleChangeMinimumHeight}
            handleChangeMaximumHeight={handleChangeMaximumHeight}
            handleChangeCustomHeight={handleChangeCustomHeight}
            handleChangeMobileHeight={handleChangeMobileHeight}
          />
        </div>
        <div className="mt-5">
          <WidthStyle
            item={stylesItem}
            handleChangeWidth={handleChangeWidth}
            handleChangeMinimumWidth={handleChangeMinimumWidth}
            handleChangeMaximumWidth={handleChangeMaximumWidth}
            handleChangeCustomWidth={handleChangeCustomWidth}
          />
        </div>
        <div className="mt-5">
          <PositioningStyle
            item={stylesItem}
            handleChangeOffsetTop={handleChangeOffsetTop}
            handleChangeOffsetBottom={handleChangeOffsetBottom}
            handleChangeOffsetLeft={handleChangeOffsetLeft}
            handleChangeOffsetRight={handleChangeOffsetRight}
            handleChangeOffsetTopMobile={handleChangeOffsetTopMobile}
            handleChangeOffsetBottomMobile={handleChangeOffsetBottomMobile}
            handleChangeOffsetLeftMobile={handleChangeOffsetLeftMobile}
            handleChangeOffsetRightMobile={handleChangeOffsetRightMobile}
            handleSelectChangePosition={handleSelectChangePosition}
            handleSelectChangePositionMobile={handleSelectChangePositionMobile}
            handleChangeZindex={handleChangeZindex}
            handleChangeZindexMobile={handleChangeZindexMobile}
          />
        </div>
        <div className="mt-5">
          <BackgroundStyle
            item={stylesItem}
            handleSelectChangeBackgroundColor={
              handleSelectChangeBackgroundColor
            }
            handleChangeBackgroundOpacity={handleChangeBackgroundOpacity}
            handleSelectChangeBackgroundGradientColor1={
              handleSelectChangeBackgroundGradientColor1
            }
            handleSelectChangeBackgroundGradientColor2={
              handleSelectChangeBackgroundGradientColor2
            }
          />
        </div>
        <div className="mt-5">
          <BorderStyle
            item={stylesItem}
            handleChangeBorderWidth={handleChangeBorderWidth}
            handleChangeBorderRadius={handleChangeBorderRadius}
            handleSelectChangeBorderStyle={handleSelectChangeBorderStyle}
            handleSelectChangeBorderColor={handleSelectChangeBorderColor}
          />
        </div>
        <div className="mt-5">
          <TypographyStyle
            item={stylesItem}
            handleSelectChangeFontFamily={handleSelectChangeFontFamily}
            handleSelectChangeFontColor={handleSelectChangeFontColor}
            handleChangeFontSize={handleChangeFontSize}
            handleChangeFontSizeMobile={handleChangeFontSizeMobile}
            handleChangeTextTransform={handleChangeTextTransform}
          />
        </div>
        <div className="mt-5">
          <ShadowStyle
            item={stylesItem}
            handleSelectChangeShadowColor={handleSelectChangeShadowColor}
            handleChangeShadowOpacity={handleChangeShadowOpacity}
            handleChangeShadowBlurRadius={handleChangeShadowBlurRadius}
          />
        </div>
        <div className="mt-5">
          <CustomCssStyle
            item={stylesItem}
            handleSelectChangeCustomCss={handleSelectChangeCustomCss}
          />
        </div> */}
        {/* <div className="mt-5">
          <Button
            fullWidth
            primary
            loading={savingStyles}
            onClick={() => {
              setSavingStyles(true);
              const bodyObj = stylesItem;
              axios
                .patch(`/pages/${id}/sections/${props.sectionId}`, bodyObj)
                .then((res) => {
                  setSavingStyles(false);
                  props.handleSaveAndRefresh();
                })
                .catch((err) => console.log(""));
            }}
          >
            Save
          </Button>
        </div> */}
        <div style={{ height: "100px" }}></div>
        <div className="footer">
          <Button
            fullWidth
            variant="primary"
            loading={savingStyles}
            onClick={() => {
              setSavingStyles(true);
              const bodyObj = { styles: stylesItem };
              axios
                .patch(
                  `/pages/${id}/sections/${props.sectionId}/styles/update`,
                  bodyObj
                )
                .then((res) => {
                  setSavingStyles(false);
                  // props.handleSaveAndRefresh();
                })
                .catch((err) => console.log(""));
            }}
          >
            Save
          </Button>
        </div>
      </SlidingPane>
      {/* <Accordion
        show={open}
        title={
          <Stack horizontal alignment="center">
            <Stack.Item fill>
              <div style={{ minWidth: "10rem" }}>
                <Text variant="bodyMd" as="p" fontWeight="regular">
                  {switchTitle(props.type)}
                </Text>
              </div>
            </Stack.Item>
            <Stack.Item>
              <ButtonGroup>
                <Button onClick={handleUp} loading={isSorting} size="slim">
                  <Icon source={ArrowUpIcon}></Icon>
                </Button>
                <Button onClick={handleDown} loading={isSorting} size="slim">
                  <Icon source={ArrowDownIcon}></Icon>
                </Button>
                <Button
                  onClick={handleChangeModalDelete}
                  loading={isSorting}
                  size="slim"
                >
                  <Icon source={DeleteMajor}></Icon>
                </Button>
              </ButtonGroup>
            </Stack.Item>
          </InlineStack>
        }
      >
        {props.type === "rich_text" && (
          <RichTextSectionEdit
            object={props.object}
            languagesArray={props.languagesArray}
            sectionId={props.sectionId}
            handleSaveAndRefresh={props.handleSaveAndRefresh}
            isSaving={props.isSaving}
            handleSavingState={props.handleSavingState}
            handleDeleteAndRefresh={props.handleDeleteAndRefresh}
          />
        )}
        {props.type === "banner" && (
          <BannerEdit
            object={props.object}
            languagesArray={props.languagesArray}
            sectionId={props.sectionId}
            handleSaveAndRefresh={props.handleSaveAndRefresh}
            isSaving={props.isSaving}
            handleSavingState={props.handleSavingState}
            handleDeleteAndRefresh={props.handleDeleteAndRefresh}
          />
        )}
        {props.type === "image" && (
          <ImageWithTextEdit
            object={props.object}
            languagesArray={props.languagesArray}
            sectionId={props.sectionId}
            handleSaveAndRefresh={props.handleSaveAndRefresh}
            isSaving={props.isSaving}
            handleSavingState={props.handleSavingState}
            handleDeleteAndRefresh={props.handleDeleteAndRefresh}
          />
        )}
        {props.type === "gallery" && (
          <GalleryEdit
            object={props.object}
            languagesArray={props.languagesArray}
            sectionId={props.sectionId}
            handleSaveAndRefresh={props.handleSaveAndRefresh}
            isSaving={props.isSaving}
            handleSavingState={props.handleSavingState}
            handleDeleteAndRefresh={props.handleDeleteAndRefresh}
            handleRefreshSections={props.handleRefreshSections}
          />
        )}
      </Accordion> */}

      {toastMarkup}
      <Modal
        open={activeChannels}
        onClose={handleChangeActiveChannels}
        title="Manage Channels"
        primaryAction={{
          content: "Done",
          onAction: handleChangeActiveChannelsDone,
        }}
        secondaryActions={[
          {
            content: "Cancel",
            onAction: handleChangeActiveChannels,
          },
        ]}
      >
        <Modal.Section>
          <ChannelsModal
            channels={props.channels}
            handleSelectedChannels={handleSelectedChannels}
            selectedChannels={selectedChannels}
          />
        </Modal.Section>
      </Modal>
    </div>
  );
  function findElementByID(array, id) {
    return array.find((element) => {
      return element.id === id;
    });
  }
});
